import client from './client';

export const getTaobaoAuthorizationStatus = () => client.get('/taobao/auth/status');

export const getTaobaoOrderSyncStatus = () => client.get('/taobao/orders/status');

export const getTaobaoApiUsageOverview = (params) => (
  client.get('/taobao/api-usage/overview', { params })
);

export const getTaobaoApiUsageDailyTrend = (params) => (
  client.get('/taobao/api-usage/daily-trend', { params })
);

export const getTaobaoApiUsageEvents = (params) => (
  client.get('/taobao/api-usage/events', { params })
);

export const createTaobaoAuthorizationUrl = () => client.get('/taobao/auth/authorize-url');

export const recheckTaobaoPublisherCapability = () => (
  client.post('/taobao/auth/publisher-capability/recheck')
);

export const getTaobaoUserBindings = (params) => (
  client.get('/taobao/user-bindings', { params })
);

export const resetTaobaoUserBinding = (payload) => (
  client.post('/taobao/user-bindings/reset', payload)
);

export const importTaobaoOrderReport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return client.post('/taobao/orders/report-import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
